import { apiFetch } from "./api";
import { stringifySnake } from "./serialization";

export function fetchMe() {
  return apiFetch("/api/v1/me");
}

export function updateMe(payload) {
  return apiFetch("/api/v1/me", {
    method: "PUT",
    body: stringifySnake(payload),
  });
}

export function changePassword(payload) {
  return apiFetch("/api/v1/me/password", {
    method: "PUT",
    body: stringifySnake(payload),
  });
}
